import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from '@/components/ui/input';

const ReviewSection = ({ title, data, tabName, main_data, tableData, role }) => {
  const hasData =
    Array.isArray(data) &&
    data.some(
      (item) =>
        item?.value &&
        item?.value !== "-" &&
        item?.value !== "" &&
        item?.value !== null &&
        item?.value !== undefined &&
        item?.value !== "₹0.00"
    );

  const cardClassName = role === "district_admin" || "admin"
    ? "mb-4 bg-white border border-3 shadow-lg p-3"
    : "mb-4";

  const cardHeaderClassName = role === "district_admin" || "admin" ? "p-4 padding-bottom-3 rounded-lg bg-teal-700 opacity-80 flex flex-row items-center justify-between" : "mb-4";
  return (
    <Card className={cardClassName}>
      <CardHeader className={cardHeaderClassName}>
        <CardTitle className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent style={{ marginTop: "15px" }}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data?.map((item, idx) => (
            <div key={idx} className="space-y-1">
              <span className="text-muted-foreground text-sm">
                {item.label}
              </span>
              <div className="font-medium">
                {item.value || <span className="text-muted-foreground"></span>}
              </div>
            </div>
          ))}
        </div>
        {tableData}
      </CardContent>
    </Card>
  );
};

export default ReviewSection;
